import React, { useContext } from 'react';
import { AccordionContextProvider } from '~/context/accordionContext';
import Accordion from './accordion';
import { ArticleContext } from '~/context/articleContext';
import { getSortedArticlesByCategory, isArticleActive } from '~/helpers/article';

const Categories = () => {
  const rootItems = getSortedArticlesByCategory({ path: '/docs' })
    .filter((c) => c.path !== '/docs/tutorials');
  const tutorialsItems = getSortedArticlesByCategory({ path: '/docs/tutorials' });

  return (
    <>
      {renderCategories(rootItems, { name: 'Documentation', icon: 'doc' })}
      {renderCategories(tutorialsItems, { name: 'Tutorials', icon: 'info' })}
    </>
  );
};

const CategoryItem = ({ item }) => {
  const { article } = useContext(ArticleContext);

  return (
    <AccordionContextProvider accordionArticle={item}>
      <Accordion.Toggle className={`nav-link nav-category ${isArticleActive(item, article) ? 'active' : ''}`}>
        {item.title}
      </Accordion.Toggle>
      <Accordion.Collapse>
        {renderSubCategories(item.path)}
      </Accordion.Collapse>
    </AccordionContextProvider>
  );
};

const CategoryLink = ({ item }) => {
  const { article } = useContext(ArticleContext);
  return (
    <a href={item.path} className={`nav-link ${isArticleActive(item, article) ? 'active' : ''}`}>
      {item.title}
    </a>
  );
};

function renderSubCategories(path) {
  const categories = getSortedArticlesByCategory({ path });
  return renderCategories(categories);
}

function renderCategories(categories, header) {
  return (
    <>
      {header && (
        <h3 className="header">
          <span className={`icon icon-${header.icon}`} />
          <span className="d-inline-block align-middle">{header.name}</span>
        </h3>
      )}
      <Accordion className={header ? 'accordion-nav' : 'nav-sub'}>
        {categories
          .map((item) => {
            return item.type === 'CATEGORY' ? (
              <CategoryItem key={item.path} item={item} />
            ) : (
              <CategoryLink key={item.path} item={item} />
            );
          })}
      </Accordion>
    </>
  );
}

export default Categories;
